// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".registration-card[data-v-f943844e]{border-bottom:1px solid#e0e0df;border-bottom-left-radius:8px;border-bottom-right-radius:8px;border-left:1px solid#e0e0df;border-right:1px solid#e0e0df}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
